module.exports = __webpack_public_path__ + "static/media/adultomayor-bw.36633eaf.png";